export default __webpack_public_path__ + "881fb2d3902f94d13e2a3b922dea24bb.png";